import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface HelpFilledProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const HelpFilled = forwardRef<SVGSVGElement, HelpFilledProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.indigo20}
          fillRule='evenodd'
          d='M12 21.972c5.505 0 9.968-4.463 9.968-9.968S17.505 2.036 12 2.036 2.032 6.5 2.032 12.004 6.495 21.972 12 21.972'
          clipRule='evenodd'
        ></path>
        <path
          fill={secondaryColor ?? '#4B49A2'}
          fillRule='evenodd'
          d='M12.975 5.839A3.452 3.452 0 0 0 9.167 7.57l-.017.032a1.271 1.271 0 0 0 .48 1.712 1.227 1.227 0 0 0 1.683-.49l.017-.031a.993.993 0 0 1 1.096-.498l.07.016c.257.06.473.237.584.48a.88.88 0 0 1-.262 1.063l-.55.42c-1.052.803-1.67 2.179-1.67 3.474 0 .695.553 1.26 1.236 1.26a1.25 1.25 0 0 0 1.238-1.26c0-.87.609-1.404 1.231-1.88a3.426 3.426 0 0 0 1.02-4.139c-.434-.95-1.344-1.658-2.348-1.89m-1.027 12.414a1.25 1.25 0 1 0-.198-2.492 1.25 1.25 0 0 0 .198 2.492'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

HelpFilled.displayName = 'HelpFilled';

export default HelpFilled;
